import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function ControleTubesView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Contrôle des Tubes</h1>
            <p>
               (VERATRACT-SAFETY) inspecte vos faisceaux tubulaires pour
              détecter précocement la corrosion, l’érosion, l’usure vibratoire
              et les piqûres, afin de sécuriser l’exploitation et d’optimiser
              la disponibilité des unités.
            </p>

            <div className="prs-hero__bullets">
              <span>📡 Courants de Foucault (RFT)</span>
              <span>🧭 Mesures d’épaisseur</span>
              <span>⚙️ Diagnostics rapides & fiables</span>
            </div>

            <a href="#contact" className="btn-primary">Demander une inspection</a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/tubes/1.jpg" alt="Contrôle RFT d’échangeur" /></div>
              <div><img src="/images/tubes/1.jpg" alt="Inspection de condenseur" /></div>
              <div><img src="/images/tubes/1.jpg" alt="Mesures d’épaisseur sur faisceau" /></div>
              <div><img src="/images/tubes/1.jpg" alt="Scanner de conduite" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== CONTENU TECHNIQUE ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Pourquoi contrôler les tubes ?</h2>
          <p>
            Les réseaux tubulaires sont soumis à des mécanismes de dégradation
            (corrosion, érosion, fatigue thermique, vibrations) qui réduisent
            l’épaisseur utile et peuvent conduire à des fuites ou ruptures.
            Un contrôle régulier permet d’anticiper les arrêts, d’allonger la
            durée de vie des équipements et d’augmenter la productivité.
          </p>

          <h3>Technologies & partenariat</h3>
          <p>
            VERATRACT-SAFETY Maroc a investi dans les techniques avancées de
            <strong> courants de Foucault</strong>, notamment le
            <strong> Remote Field Testing (RFT – champ lointain)</strong>,
            et a formé/qualifié son personnel pour ces méthodes à haute sensibilité.
            Nous sommes le <strong>représentant officiel</strong> en Afrique du Nord
            et au Moyen-Orient de <strong>Russell Technologies Canada</strong>,
            concepteur/fabricant de solutions de référence pour l’inspection des tubes.
          </p>

          <h3>Équipements concernés</h3>
          <ul>
            <li>Chaudières à tubes de fumée (RFT)</li>
            <li>Chaudières à tubes d’eau (RFT)</li>
            <li>Échangeurs et condenseurs</li>
            <li>Fond et grands bacs de stockage (cartographie d’épaisseur)</li>
            <li>Conduites enterrées (scanner interne)</li>
            <li>Conduites métalliques aériennes (scanner externe)</li>
          </ul>

          <h3>Ce que nous détectons</h3>
          <ul>
            <li>Perte d’épaisseur par corrosion, érosion, abrasion</li>
            <li>Piqûration et corrosion sous dépôts</li>
            <li>Désordres liés aux vibrations et à la fatigue thermique</li>
          </ul>


          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
